import {TGiftVoucherTransferRequest} from './t-gift-voucher-transfer-request';
import {MBulkGiftVoucherCustomer} from '../../../master-files/m-gift-voucher-bulk-customer/model/m-bulk-gift-voucher-customer-dto';
import {MBranch} from '../../../service/m-branch/model/m-branch';

export class MainTGiftVoucherTransfer {
  indexNo: number;
  transactionNumber: number;
  transactionDate: string;
  inDate: number;
  outDate: number;
  reference: string;
  remarks: string;
  status: string;
  fromBranch: MBranch;
  toBranch: MBranch;
  tGiftVoucherTransferRequestList: TGiftVoucherTransferRequest [] = [];
  mBulkGiftVoucherCustomer: MBulkGiftVoucherCustomer;
  giftVoucherType: string;
  giftVoucherBulkCustomerCommisionP: number;
  giftVoucherBulkCustomerCommisionV: number;
}



// WEBPACK FOOTER //
// ./src/app/view/transactions/t-gift-voucher-transfer/model/t-gift-voucher-transfer.ts